export const FETCH_ORDER = 'FETCH_ORDER';
export const CREATE_ORDER = 'CREATE_ORDER';
export const CREATE_ORDER_ALL_DECKS = 'CREATE_ORDER_ALL_DECKS';
export const UPDATE_ORDER_TO_PAY_FROM_CREDIT = 'UPDATE_ORDER_TO_PAY_FROM_CREDIT';
export const UPDATE_ORDER_CODE = 'UPDATE_ORDER_CODE';
